// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0fMAO","children":"styles_children__K1ky8"};